<template lang="pug">
  v-row(align='center' justify='center')
    v-col(xs='12' sm='12' md='12')
      v-toolbar(color='red' style='margin-top:-12px')
        v-toolbar-title
          span(style='color:#ffffff; font-size:25px') Form Pengisian Tamu PT. BIB 
        v-spacer
    v-col(xs='11' sm='11' md='11')
      v-stepper(v-model='e1')
        v-stepper-header
          v-stepper-step(:complete='e1 > 1' step='1')
            | Video
          v-divider
          v-stepper-step(:complete='e1 > 2' step='2')
            | Form
          v-divider
          v-stepper-step(:complete='e1 > 3' step='3')
            | Success
        v-stepper-items
          v-stepper-content(step='1')
            v-card(height='auto')
              v-row(align='center' justify='center')
                v-col(xs='12' sm='12' md='12' style='text-align: center')
                  span(style='font-size:20px') Form Pengisian Tamu PT. BIB 
              v-row(align='center' justify='center' :class="{'costum-margin' : $vuetify.breakpoint.xs }")
                v-col(xs='12' sm='12' md='12')
                  video#video(controls='' width='100%' height='420')
                    source(src="https://storage.googleapis.com/ipermit-data/video/M%20-%20Video%20Induksi%20Tamu_Subtitle%202021%20-%20REENCODED.mp4" type='video/mp4')
                    object(type='application/x-shockwave-flash' data='player.swf' width='640' height='360')
                      param(name='movie' value='player.swf')
                      param(name='flashvars' value='autostart=true&controlbar=over&image=poster.jpg&file=http://clips.vorwaerts-gmbh.de/VfE_flash.mp4')
                      img(src='poster.jpg' alt='Big Buck Bunny' title='No video playback capabilities, please download the video below' width='640' height='360')
              v-row(align='center' justify='center')
                v-col(xs='12' sm='12' md='12' style='text-align: center')
                  v-btn(color='primary' @click='e1 = 2; scrollTop();')
                    | Continue
          v-stepper-content(step="2")
            ModalNotifSubVisit( :openModalNotif="openModalNotif", @onClose="closeModal", @onConfirm="submit")
            v-card(class="mb-12"
              height="auto" style="padding:20px")
                v-layout(row wrap)
                  v-flex(xs4 sm3 v-if="!$vuetify.breakpoint.xs")
                    p(class="headerSection") 
                      span(class="mustFill") *
                      span  Nama Lengkap
                  v-flex(xs11 sm5)
                    v-text-field(id="fsv-nama-lengkap" class="inputDefault" v-model='visitorName' label="Nama Lengkap" disabled)
                  v-flex(xs1 sm4)

                  v-flex(xs4 sm3 v-if="!$vuetify.breakpoint.xs")
                    p(class="headerSection") 
                      span(class="mustFill") *
                      span  Email
                  v-flex(xs11 sm5)
                    v-text-field(id="fsv-email" class="inputDefault" v-model='visitorEmail' label="Email" disabled)
                  v-flex(xs1 sm4)

                  v-flex(xs4 sm3 v-if="!$vuetify.breakpoint.xs")
                    p(class="headerSection") 
                      span(class="mustFill") *
                      span  Nomor Handphone
                  v-flex(xs11 sm5)
                    v-text-field(class="inputDefault" 
                      v-model='visitorPhone' 
                      id="fsv-nohp"
                      label="Nomor Handphone" 
                      disabled
                      :rules='[visitorRules.required, visitorRules.phone]'
                      
                    )
                  v-flex(xs1 sm4)

                  v-flex(xs4 sm3 v-if="!$vuetify.breakpoint.xs")
                    p(class="headerSection") 
                      span(class="mustFill") *
                      span  Nomor Darurat
                  v-flex(xs11 sm5)
                    v-text-field(id="fsv-no-darurat" class="inputDefault" v-model='visitorEmergency' label="Nomor Darurat" :rules='[visitorRules.required, visitorRules.phone]' maxlength=15 counter)
                  v-flex(xs1 sm4)

                  v-flex(xs3, sm3 v-if="errorNotif")
                  v-flex(xs9, sm9 v-if="errorNotif" style="margin-top:-15px;margin-bottom:15px")
                    label(v-if="errorNotif" style="color:red;text-align:center") {{errorNotif}}

                  v-flex(xs4 sm3 v-if="!$vuetify.breakpoint.xs") 
                    p(class="headerSection") 
                      span(class="mustFill") *
                      span  Golongan Darah
                  v-flex(xs11 sm5)
                    v-autocomplete(
                      class="inputDefault"
                      id="fsv-golongan-darah"
                      v-model="visitorBloodType"
                      :items="golonganDarahList"
                      label="Golongan Darah")
                  v-flex(xs1 sm4)

                  v-flex(xs4 sm3 v-if="!$vuetify.breakpoint.xs")
                    p(class="headerSection") 
                      span(class="mustFill") *
                      span  Nomor KTP
                  v-flex(xs11 sm5)
                    v-text-field(
                      class="inputDefault" 
                      v-model='visitorKtp'
                      id="fsv-no-ktp" 
                      label="NIK"
                      counter
                      maxlength=16
                      :rules="[value => value.length <= 16 || 'Max 16 characters', visitorRules.ktp]"
                    )
                  v-flex(xs1 sm4)

                  v-flex(xs5 sm3 ) 
                    p(:class="{'headerSection' :!$vuetify.breakpoint.xs}") 
                      span(class="mustFill") *
                      span  Upload KTP
                  v-flex(xs6 sm3 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
                    v-file-input(id="fsv-upload-ktp" :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung" accept=".pdf,.png,.jpg,.jpeg")
                      template(v-slot:selection="{ text }" )
                        v-chip(small label color="primary")   {{ text }}
                  v-flex(xs6 sm3 class="attachmentName" v-else)
                    span(id="fsv-upload-ktp") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                    v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                      v-icon mdi-close
                  v-flex(xs1 sm4)

                  v-flex(xs12 sm12)
                  
                  v-flex(xs4, sm3 v-if="apdInfo !== 'Tidak'")
                    p(:class="{'headerSection' :!$vuetify.breakpoint.xs}") 
                      span(class="mustFill") *
                      span  APD Helm
                  v-flex(xs7, sm5 v-if="apdInfo !== 'Tidak'")
                    v-radio-group(id="fsv-apd-helm" v-model="visitorApd.helm", row style="margin-top:-5px")
                      v-radio(id="fsv-apd-helm" label="Ya", value="Ya")
                      v-radio(id="fsv-apd-helm" label="Tidak", value="Tidak")
                  v-flex(xs1, sm4 v-if="apdInfo !== 'Tidak'")

                  v-flex(xs4, sm3 v-if="apdInfo !== 'Tidak'")
                    p(:class="{'headerSection' :!$vuetify.breakpoint.xs}") 
                      span(class="mustFill" style="padding-top:10px") *
                      span  APD Rompi
                  v-flex(xs7, sm5 v-if="apdInfo !== 'Tidak'")
                    v-radio-group(id="fsv-apd-rompi" v-model="visitorApd.rompi", row style="margin-top:-20px" :class="{'custom-xs-radio': $vuetify.breakpoint.xs}")
                      v-radio(id="fsv-apd-rompi" label="Ya", value="Ya")
                      v-radio(id="fsv-apd-rompi" label="Tidak", value="Tidak")
                      v-text-field(id="fsv-ukuran-rompi" class="inputDefault" :disabled="visitorApd.rompi == 'Tidak'" style="padding-top:15px" v-model='visitorApd.ukuranRompi' label="Ukuran Rompi")
                  v-flex(xs1, sm4 v-if="apdInfo !== 'Tidak'")

                  v-flex(xs4, sm3 v-if="apdInfo !== 'Tidak'")
                    p(:class="{'headerSection' :!$vuetify.breakpoint.xs}" style="margin-top:-18px") 
                      span(class="mustFill" ) *
                      span  APD Sepatu
                  v-flex(xs7, sm5 v-if="apdInfo !== 'Tidak'")
                    v-radio-group(id="fsv-apd-sepatu" v-model="visitorApd.sepatu", row style="margin-top:-40px" :class="{'custom-xs-radio': $vuetify.breakpoint.xs}")
                      v-radio(id="fsv-apd-sepatu" label="Ya", value="Ya")
                      v-radio(id="fsv-apd-sepatu" label="Tidak", value="Tidak")
                      v-text-field(id="fsv-ukuran-sepatu" class="inputDefault" :disabled="visitorApd.sepatu == 'Tidak'" style="padding-top:15px" v-model='visitorApd.ukuranSepatu' label="Ukuran Sepatu")
                  v-flex(xs1, sm4 v-if="apdInfo !== 'Tidak'")
            v-btn(text @click="e1 = 1;" v-if="!$vuetify.breakpoint.xs") Back
            v-btn(color="red" style="color:white;margin-left:20px;margin-right:20px" @click='handleOpenModal(18);' v-if="!$vuetify.breakpoint.xs") Cancel Kunjungan
            v-btn(color="primary" @click=' submit(7);' :disabled='!isPage2Complete' v-if="!$vuetify.breakpoint.xs") Submit
            v-flex(v-else)
              v-col()
                v-btn(color="primary" @click=' submit(7);' :disabled='!isPage2Complete' block) Submit
              v-col()
                v-btn(color="red" style="color:white;" @click='handleOpenModal(18);' block) Cancel Kunjungan

          v-stepper-content(step='3')
            v-card(height='66vh')
              v-row(align='center' justify='center')
                v-col(xs='12' sm='12' md='12' style='text-align: center')
                  v-icon(color="blue" large ) mdi-check-circle
              v-row(align='center' justify='center')  
                v-col(xs='12' sm='12' md='12' style='text-align: center')
                  span(style='font-size:20px') {{this.submitedText}}
              v-row(align='center' justify='center')
                v-col(xs='12' sm='12' md='12' style='text-align: center;margin-top:-20px')
                  span(style='font-size:20px') Data anda telah berhasil disimpan
              v-row(align='center' justify='center')
                v-col(xs='12' sm='12' md='12' style='text-align: center;margin-top:-20px' v-if="status == 7")
                  span(style='font-size:14px') Silahkan tutup halaman ini, Selanjutnya anda akan mendapatkan email link induksi pada H-1
           
</template>

<script>
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";
import ModalNotifSubVisit from "./ModalNotifVisitor.vue";

export default {
  name: "FormSubmitVisitor",
  components: {
    ModalNotifSubVisit
  },
  props: ["dataVisitor","ipForm","visitorToken","visitorInfo"],
  data() {
    return {
      // Todo: Change this back to 1
      e1: 1,
      openModalNotif : false,
      golonganDarahList:["A","AB","B","O"],
      visitorName :'',
      status: null,
      visitorId :'',
      visitorPhone:'', 
      visitorEmail:'',
      visitorEmergency:'',
      visitorBloodType:'',
      visitorKtp:'',
      errorNotif:'',
      apdInfo : '',
      visitorKtpUploadId:'',
      visitorAddress: '',
      visitorApd :{
        helm: '',
        sepatu:'',
        rompi:'',
        ukuranRompi:'',
        ukuranSepatu :''
      },

      
      uploadId: null,
      docPendukung: null,
      submitedText :"",
      submitClick: false,
      rules: [
        value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
      ],
      emptyUpload: new File([""], "", {
        type: "",
      }),
    };
  },
  mounted: async function() {
    this.$store.dispatch("fetchLocations");
    this.uploadId = Date.now();
    this.visitorId = this.visitorToken.idVisitor
    this.apdInfo = this.dataVisitor.permitInfo.ipApd
  },
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers", "visitorRules"]),
    rompiStatus() {
      return this.visitorApd.rompi
    },
    sepatuStatus() {
      return this.visitorApd.sepatu
    },
    selectedLoc(){
      let tempLoc = []
      let locationCode;
      
      if(this.dataUsers.location instanceof Array){
        locationCode = this.dataUsers.location[0];
      }else{
        locationCode = this.dataUsers.location;
      }

      for(let i = 0; i < this.lokasi.length; i++){
        tempLoc.push({code: locationCode, name: this.lokasi[i]});
      }
      return tempLoc
    },
    isPage2Complete: function() {
      let logic = false;
      if (this.apdInfo == 'Tidak') {
        logic = this.visitorName &&
                this.visitorEmail &&
                this.visitorPhone &&
                (this.visitorEmergency && (this.visitorRules.phone(this.visitorEmergency) != 'Invalid Phone Number Format') && !this.errorNotif) &&
                this.visitorBloodType &&
                (this.visitorKtp && (this.visitorRules.ktp(this.visitorKtp) != 'Only Numbers are allowed.')) &&
                this.docPendukung &&
                this.visitorAddress;
      }
      else {
        logic = this.docPendukung && 
                !!this.visitorApd.helm && !!this.visitorName &&  !!this.visitorPhone && !!this.visitorEmail && 
                (this.visitorEmergency && (this.visitorRules.phone(this.visitorEmergency) != 'Invalid Phone Number Format') && !this.errorNotif) && 
                !!this.visitorBloodType && 
                (this.visitorKtp && (this.visitorRules.ktp(this.visitorKtp) != 'Only Numbers are allowed.')) && !! this.visitorAddress && 
                (this.visitorApd.rompi == "Tidak" || this.visitorApd.ukuranRompi) && (this.visitorApd.sepatu == "Tidak" || this.visitorApd.ukuranSepatu);
      }
      return logic
    }
  },
  methods: {
    updatePemegangIzin(user) {
      this.pemegangIzin = user;
    },
    clearDate(){
      this.endDate=null;
      this.startMenu = false;
    },
    formatDate:helper.formatDate,
    scrollTop(){
      window.scrollTo(0,0);
    },
    closeModal(params){
      this.openModalNotif = params
    },
    handleOpenModal(){
      this.openModalNotif = true
    },
    submit(status){
      this.submitClick = true;
      this.status = status;
      status == 7 && (this.submitedText = "Terimakasih telah mengisi form tamu PT. Borneo Indobara,");
      status == 18 && (this.submitedText = "Terimakasih telah konfirmasi,")
      status == 18 && (this.openModalNotif = false)
      let formData = {
        visitorName : this.visitorName,
        status : this.status,
        visitorPhone : this.visitorPhone,
        visitorEmail : this.visitorEmail,
        visitorEmergency : this.visitorEmergency,
        visitorBloodType : this.visitorBloodType,
        visitorKtp : this.visitorKtp,
        visitorKtpUploadId : JSON.stringify(this.visitorKtpUploadId),
        visitorAddress : this.visitorAddress,
        visitorApd : this.visitorApd
      }
      // console.log(formData)
      // this.e1 = 3
      const config = {
        method:  "post",
        url: `${this.API_URL}/v1/requests/submitVisitorData`,
        headers: {"Content-Type": "application/json", "Authorization": `Bearer ${this.visitorToken.token}`},
        data: formData
      };
      axios(config).then(res => {
        if(res.data.data == "Done"){
          this.e1 = 3
        }
      }).catch(err =>{
        console.log(err.response.data)
      });

    },
    deleteDocPendukung(name){
      let id = this.visitorKtpUploadId.toString();  
      axios
        .post(`${this.API_URL}/v1/requests/deleteFileGCS`, 
        {
          uploadId: id,
          folderName: name
        },
        {
          headers: { Authorization: `Bearer ${this.visitorToken.token}` },
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    backHome(){
      this.$router.push("/my-permit");
    },
    backStep(){
      this.e1--
    },
    docName(name){
      return this.$setFilename(name);
    }
  },
  watch: {
    rompiStatus(val){
      if (val == 'Tidak') this.visitorApd.ukuranRompi = '';
    },
    sepatuStatus(val){
      if (val == 'Tidak') this.visitorApd.ukuranSepatu = '';
    },
    docPendukung(params){
      if(params && params.size < 10000000){
         let formData = new FormData();
          this.visitorKtpUploadId = Date.now();
        formData.append('uploadId', this.visitorKtpUploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.visitorToken.token}`}});
      }
    },
    visitorInfo(param){
      this.visitorName = param.name
      this.visitorEmail = param.email
      this.visitorPhone = param.phone
    },
    visitorEmergency(param){
      if(this.visitorPhone == param){
        this.errorNotif = "No Handpone dan No Darurat tidak boleh sama" 
      }else{
        this.errorNotif = ""
      }
    },
  }
};
</script>

<style>
.costum-margin{
  margin-top:-120px;
}
.ck-editor__editable {
    min-height: 300px;
    max-height: 300px;
    resize:none;
}
.mustFill {
  color: #EA5164;
}
.custom-xs-radio{
  padding-top:22px;
}
</style>
